import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { useApi } from '../../hooks/use_api';
import { useNodeInfo } from '../../hooks/use_node_info';
import { EmbedBlock } from './EmbedBlock';

// /embed/entity/:entityId — the page an iframe on any site shows: one
// entity's embed block (backend services/embed_blocks.py) and nothing else.
// Public: no login, no Layout, and AuthContext skips Keycloak on this path.
// ?theme=light|dark picks the colours (ThemeContext), else the viewer's own
// system preference. nginx.conf lets this path alone be framed elsewhere.
function EmbedBlockPage() {
    const { entityId } = useParams();
    const api = useApi();
    const { nodeName } = useNodeInfo();
    // undefined while loading; null when there is no public embed (off, or no such entity).
    const [block, setBlock] = useState(undefined);

    useEffect(() => {
        let alive = true;
        api.get(`/api/entities/${entityId}/embed`)
            .then(data => { if (alive) setBlock(data || null); })
            .catch(() => { if (alive) setBlock(null); });
        return () => { alive = false; };
    }, [api, entityId]);

    if (block === undefined) {
        return <div className="embed-page embed-page--empty"><Spin /></div>;
    }
    if (block === null) {
        return <div className="embed-page embed-page--empty">This embed is not available.</div>;
    }
    return (
        <div className="embed-page">
            <EmbedBlock block={block} origin={window.location.origin} nodeName={nodeName} />
        </div>
    );
}

export default EmbedBlockPage;
